// this file is automatically generated by git.version.ts script
export const versions = {commit: '717bf58f5', tag: '2026.4.003-RELEASE'};
